import { useEffect } from 'react';

const useMouseMove = (ref: any, callback: (x: number, y: number) => void) => {
  useEffect(() => {
    const handleClickOutside = (evt: MouseEvent) => {
      if (ref.current && ref.current.contains(evt.target)) {
        callback(evt.clientX, evt.clientY);
      }
    };
    document.addEventListener('mousemove', handleClickOutside);
    return () => {
      document.removeEventListener('mousemove', handleClickOutside);
    };
  }, []);
};

export default useMouseMove;
